<template>
  <div class="container">
    <keep-alive>
      <transition name="fade" mode="out-in">
        <component
          :is="currentComponent"
          @switchToRegister="switchToRegister"
          @switchToLogin="switchToLogin"
          data-aos="flip-left"
          data-aos-duration="700"
        ></component>
      </transition>
    </keep-alive>
  </div>
</template>
  
  <script>
import TheRegister from "./TheRegister.vue";
import TheAuth from "./TheAuth.vue";
import AOS from "aos";

export default {
  data() {
    return {
      currentComponent: TheAuth, // Начальный компонент — форма логина
    };
  },
  methods: {
    switchToRegister() {
      this.currentComponent = TheRegister;
    },
    switchToLogin() {
      this.currentComponent = TheAuth;
    },
    refreshAOS() {
      this.$nextTick(() => {
        AOS.refresh();
      });
    },
  },
};
</script>
  
  <style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85rem;
}

</style>